<template>
  <img :src="imgSrc" :alt="alt">
</template>

<script>
  export default {
    name: 'webp-image',
    props: {
      src: {
        type: String,
        default: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
      },
      alt: {
        type: String,
        default: '图片'
      }
    },
    computed: {
      imgSrc () {
        const imageSrc = this.http2https(this.src)
        return this.$store.getters.supportWebp ? imageSrc + '?imageMogr2/format/webp' : imageSrc
      }
    },
    methods: {
      http2https (link) {
        return link.replace('http://', 'https://')
          .replace('cdn.llsapp.com', 'cdn.llscdn.com')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// WebpImage.vue?215a606a